import { LibraryItemType } from "@src/types.generated";

// The item-type copy the pills and picker show. Kept here rather than read
// from ContentAvatar so the composer doesn't pull the media-editor bundle in.
const LABELS: Partial<Record<LibraryItemType, string>> = {
  [LibraryItemType.Course]: "Course",
  [LibraryItemType.Module]: "Module",
  [LibraryItemType.Skill]: "Check-in",
  [LibraryItemType.Task]: "Checklist",
  [LibraryItemType.TrainingResource]: "Resource",
  [LibraryItemType.Audit]: "Audit",
  [LibraryItemType.ScormCourse]: "SCORM Course",
};

export const libraryItemTypeLabel = (type: LibraryItemType): string =>
  LABELS[type] ?? "Opus item";
